import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useGettext } from '@jshmrtn/vue3-gettext';
import { Flash } from '@/core/Flash';
import NewsForm from '@/modules/news/components/NewsForm.vue';
import { News } from '@/modules/news/News';


export default /*@__PURE__*/_defineComponent({
  __name: 'NewsCreate',
  setup(__props) {

const { $gettext } = useGettext();
const router = useRouter();
const newsItem = ref<Partial<News>>({
	user_type: [],
	content: [],
});

const saved = (news) => {
	Flash.success($gettext('Nyhet tillagd'));
	router.push({
		name: 'news.edit',
		params: { id: news.id },
	});
};

const cancel = () => {
	router.push({ name: 'news.index' });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(NewsForm, {
    "page-title": _unref($gettext)('Ny nyhet'),
    "news-item": newsItem.value,
    onSaved: saved,
    onCancel: cancel
  }, null, 8, ["page-title", "news-item"]))
}
}

})